import React from "react";
import PropTypes from "prop-types";
import isEqual from "lodash/isEqual";

import {
  inlineElements,
  generateStyle,
  setOverLay,
  l,
  generateImageCss,
} from "../../functions";

import { MyDraggable as Draggable } from "../../components/Core";
import HoverBar from "../../components/HoverBar";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Container, Row, Col } from "reactstrap";
import state from "../../state";
import Rating from "../../components/Rating";

import { makeStyles } from "@material-ui/core/styles";
import Icon from "../../components/Icons";
import { connect } from "react-redux";
const mapStateToProps = (state) => {
  return {
    fetchedProducts: state.rootReducer.fetchedProducts || {},
    currentLang: state.rootReducer.currentLang || 1,
    settings: state.rootReducer?.appearanceSettings || {},
    currentDevice: state.rootReducer?.currentDevice || "xl",
  };
};

const useStyles = makeStyles((theme) => ({
  layout1: (props) => ({
    "& .product-image:hover > span": {
      backgroundColor: setValue(props.cpColor01),
      color: setValueContent(props.cpColor01),
    },
    "& .product-info .price-txt": {
      color: setValue(props.cpColor01),
    },
  }),
  layout2: (props) => ({
    "& li .product-info span.name a": {
      color: setValue(props.cpColor01),
    },
    "& li .product-box span.prom_txt.sale": {
      backgroundColor: setValue(props.cpColor02),
      color: setValueContent(props.cpColor02),
    },
  }),
  layout3: (props) => ({
    "& li .product-info.center span.price-txt": {
      color: setValue(props.cpColor01),
    },
    "& li .product-box span.prom_txt.sale": {
      backgroundColor: setValue(props.cpColor02),
      color: setValueContent(props.cpColor02),
    },
  }),
  layout4: (props) => ({
    "& li .product-box figcaption": {
      backgroundColor: setValue(props.cpColor01),
    },
    "& li .product-box figcaption h3": {
      borderBottomColor: setValueContent(props.cpColor01),
    },
    "& li .product-box figcaption h3 a, & li .product-box figcaption span.price-txt,& li .product-box figcaption span.price-txt span.old-price, & li .product-box figure .rating svg":
      {
        color: setValueContent(props.cpColor01),
      },
    "& li .product-box span.prom_txt.sale": {
      backgroundColor: setValue(props.cpColor02),
      color: setValueContent(props.cpColor02),
    },
  }),
  layout5: (props) => ({
    "& li .product-box figcaption": {
      backgroundColor: setValue(props.cpColor01),
    },
    "& li .product-box figure:hover figcaption h3": {
      borderBottomColor: setValueContent(props.cpColor01),
    },
    "& li .product-box figure:hover figcaption h3 a, & li .product-box figure:hover figcaption span.price-txt,& li .product-box figure:hover figcaption span.price-txt span.old-price, & li .product-box figure .rating svg":
      {
        color: setValueContent(props.cpColor01),
      },
    "& li .product-box span.prom_txt.sale": {
      backgroundColor: setValue(props.cpColor02),
      color: setValueContent(props.cpColor02),
    },
    "& li .product-box figure:hover figcaption": {
      boxShadow: "0 0 0 10px " + setValue(props.cpColor03),
    },
  }),
  layout6: (props) => ({
    "& li .product-box figcaption": {
      backgroundColor: setValue(props.cpColor01),
    },
    "& li .product-box figcaption h3": {
      borderBottomColor: setValueContent(props.cpColor01),
    },
    "& li .product-box figure figcaption h3 a, & li .product-box figure figcaption span.price-txt,& li .product-box figure figcaption span.price-txt span.old-price, & li .product-box figure .rating svg":
      {
        color: setValueContent(props.cpColor01),
      },
    "& li .product-box span.prom_txt.sale": {
      backgroundColor: setValue(props.cpColor02),
      color: setValueContent(props.cpColor02),
    },
  }),
}));

function setValue(value) {
  return value + importantValue(value);
}

function setValueContent(color) {
  return (
    (color !== null && isDark(color) ? "#FFF" : "#000") + importantValue(color)
  );
}

function importantValue(value) {
  return value !== null ? " !important" : "";
}

function isDark(color) {
  // Variables for red, green, blue values
  var r, g, b, hsp;

  // Check the format of the color, HEX or RGB?
  if (color) {
    if (color.match(/^rgb/)) {
      // If HEX --> store the red, green, blue values in separate variables
      color = color.match(
        /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/
      );

      r = color[1];
      g = color[2];
      b = color[3];
    } else {
      // If RGB --> Convert it to HEX: http://gist.github.com/983661
      color = +(
        "0x" + color.slice(1).replace(color.length < 5 && /./g, "$&$&")
      );

      r = color >> 16;
      g = (color >> 8) & 255;
      b = color & 255;
    }

    // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
    hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));

    // Using the HSP value, determine whether the color is light or dark
    if (hsp > 127.5) return false;
    else return true;
  } else return true;
}

function InitProduct({ props }) {
  let { payload, currentDevice, settings } = props;

  if (payload === null) payload = props.options.payload;

  const elementCss =
    payload && (payload["settings_" + currentDevice] || payload.settings);
  const starStyle = elementCss?.starStyle || {};
  const priceStyle = elementCss?.priceStyles || {};
  const productImageCss = generateImageCss(elementCss);

  const starCss = {
    color: starStyle?.color || "goldenrod",
    alignment: starStyle?.starPosition || "center",
    fontSize: starStyle?.size || 16,
  };

  const {
    showProductSorting,
    showPaginationSummary,
    currentDesign,
    cpColor01,
    cpColor02,
    cpColor03,
    showat,
    titleTag: MyHeading = "h4",
  } = payload.datas;

  let productIndex = "relProductsPerRowLg";
  if (currentDevice == "md") {
    productIndex = "relProductsPerRowMd";
  }
  if (currentDevice == "sm") {
    productIndex = "relProductsPerRowSm";
  }
  if (currentDevice == "xs") {
    productIndex = "relProductsPerRowXs";
  }

  const relProducts = payload?.datas[productIndex];

  const heading = {
    h6: 16,
    h5: 20,
    h4: 24,
    h3: 26,
    h2: 30,
    h1: 32,
  };

  const cssSettings = generateStyle(payload, "container");
  const cssTextSettings =
    generateStyle(payload, "text", MyHeading.toUpperCase()) || {};

  if (!cssTextSettings?.fontSize) {
    cssTextSettings.fontSize = heading[MyHeading];
  }

  const classes = useStyles({
    cpColor01: cpColor01,
    cpColor02: cpColor02,
    cpColor03: cpColor03,
  });

  let atclabel = l("Add to cart");

  if (payload.datas) {
    if (payload.datas["atclabel_" + props.currentLang])
      atclabel = payload.datas["atclabel_" + props.currentLang];
    else if (payload.datas["atclabel"]) atclabel = payload.datas["atclabel"];
  }

  const cssOldPrice = settings["old_price_color"] || {};
  const cssPrice = settings["price_color"] || {};
  const newPrice = {
    color: priceStyle.priceColor || cssPrice.color || "",

    fontSize: priceStyle.priceSize || settings["body"]?.size || 16,
  };
  const oldPrice = {
    color: priceStyle.oldPriceColor || cssOldPrice.color || "",

    // fontSize: priceStyle.priceSize || settings['body']?.size || 16
  };

  if (!cssTextSettings?.color) {
    cssTextSettings.color = "#000";
  }
  if (!cssTextSettings?.textAlign) {
    cssTextSettings.textAlign = "center";
  }

  return (
    <Container fluid={payload.fullContainer} style={cssSettings}>
      {setOverLay(payload)}
      <Row>
        <Col xs={12} className="fullcol">
          <div className="product-list-main">
            {showProductSorting !== undefined &&
            showProductSorting !== null &&
            showProductSorting === false ? null : (
              <div className="product-action">
                <div className="row">
                  <div className="col-xs-12 col-sm-4"></div>
                  <div className="col-6 col-sm-4">
                    <p
                      className="product-category-count"
                      style={cssTextSettings}
                    >
                      <span className="countlist">
                        {Object.keys(props.fetchedProducts).length}
                      </span>{" "}
                      Products
                    </p>
                  </div>
                  <div className="col-6 col-sm-4">
                    <div className="form-inline sortPagiBar clearfix">
                      <div className="productsSort">
                        <form>
                          <label>Sort by</label>
                          <select className="selectProductSort form-control">
                            <option value="">Price: Lowest first</option>
                            <option value="">Price: Heighst first</option>
                          </select>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className="product-list-wrap">
              <div
                className={`product-list ${
                  currentDesign ? "layout" + currentDesign : ""
                } ${currentDesign ? classes["layout" + currentDesign] : ""}`}
              >
                <ul className="row">
                  {Object.keys(props.fetchedProducts)
                    .slice(0, 12 / relProducts)
                    .map((id_product, index) => {
                      const product = props.fetchedProducts[id_product];
                      return (
                        <li
                          className={`col-${relProducts} product-wrap`}
                          key={index}
                          style={cssTextSettings}
                        >
                          {currentDesign === 1 && (
                            <div>
                              <div
                                className="product-image"
                                style={{ ...productImageCss }}
                              >
                                <a href="#">
                                  <img src={product.image} alt="product" />
                                </a>
                                {product.price["reduction-label"] !== false && (
                                  <span>
                                    {product.price["reduction-label"]}
                                  </span>
                                )}
                              </div>
                              <div className="product-info">
                                <MyHeading
                                  className="name"
                                  style={cssTextSettings}
                                >
                                  <a href="#" style={cssTextSettings}>
                                    {product.name}
                                  </a>
                                </MyHeading>
                                <Rating rate={3} on={5} style={starCss} />

                                <div
                                  className="price-section"
                                  style={{
                                    textAlign:
                                      priceStyle?.pricePosition || "center",
                                  }}
                                >
                                  <span className="price-txt" style={newPrice}>
                                    {" "}
                                    <span
                                      className="old-price"
                                      style={oldPrice}
                                    >
                                      $99.99
                                    </span>{" "}
                                    $9.99{" "}
                                  </span>
                                  <span className="price-over">
                                    Visual Builder is not showing actual product
                                    price. Prices here are used to show how it
                                    will look at Store Front
                                  </span>
                                </div>

                                {showat && (
                                  <button
                                    className="atcpl"
                                    style={{
                                      color: payload.datas.atcc,
                                      backgroundColor: payload.datas.atcbc,
                                    }}
                                  >
                                    {atclabel}
                                  </button>
                                )}
                              </div>
                            </div>
                          )}
                          {(currentDesign === 2 || currentDesign === 3) && (
                            <div className="product-box">
                              <div
                                className="product-image"
                                style={{ ...productImageCss }}
                              >
                                <a href="#">
                                  <img src={product.image} alt="product" />
                                </a>
                              </div>
                              <div
                                className={`product-info${
                                  currentDesign === 3 ? " center" : ""
                                }`}
                              >
                                <MyHeading className="name">
                                  <a href="#" style={cssTextSettings}>
                                    {product.name}
                                  </a>
                                </MyHeading>
                                <Rating rate={3} on={5} style={starCss} />

                                {product.price["reduction-label"] !== false && (
                                  <span className="prom_txt sale">
                                    {product.price["reduction-label"]}
                                  </span>
                                )}
                                <div
                                  className="price-section"
                                  style={{
                                    textAlign:
                                      priceStyle?.pricePosition || "center",
                                  }}
                                >
                                  <span className="price-txt" style={newPrice}>
                                    {" "}
                                    <span
                                      className="old-price"
                                      style={oldPrice}
                                    >
                                      $99.99
                                    </span>{" "}
                                    $9.99{" "}
                                  </span>
                                  <span className="price-over">
                                    Visual Builder is not showing actual product
                                    price. Prices here are used to show how it
                                    will look at Store Front
                                  </span>
                                </div>

                                {showat && (
                                  <button
                                    className="atcpl"
                                    style={{
                                      color: payload.datas.atcc,
                                      backgroundColor: payload.datas.atcbc,
                                    }}
                                  >
                                    {atclabel}
                                  </button>
                                )}
                              </div>
                            </div>
                          )}
                          {(currentDesign === 4 ||
                            currentDesign === 5 ||
                            currentDesign === 6) && (
                            <div className="product-box">
                              <figure>
                                {((currentDesign === 4 ||
                                  currentDesign === 5) && (
                                  <div style={{ ...productImageCss }}>
                                    <img src={product.image} alt="product" />
                                  </div>
                                )) || (
                                  <a href="#" style={{ ...productImageCss }}>
                                    <img src={product.image} alt="product" />
                                  </a>
                                )}
                                <figcaption className="product-info">
                                  <MyHeading style={cssTextSettings}>
                                    {product.name}
                                  </MyHeading>
                                  <Rating rate={3} on={5} style={starCss} />

                                  <div
                                    className="price-section"
                                    style={{
                                      textAlign:
                                        priceStyle?.pricePosition || "center",
                                    }}
                                  >
                                    <span
                                      className="price-txt"
                                      style={newPrice}
                                    >
                                      {" "}
                                      <span
                                        className="old-price"
                                        style={oldPrice}
                                      >
                                        $99.99
                                      </span>{" "}
                                      $9.99{" "}
                                    </span>
                                    <span className="price-over">
                                      Visual Builder is not showing actual
                                      product price. Prices here are used to
                                      show how it will look at Store Front
                                    </span>
                                  </div>

                                  {(currentDesign === 4 ||
                                    currentDesign === 5) && (
                                    <a href="#" className="btn">
                                      Show Now
                                    </a>
                                  )}
                                  {showat && (
                                    <button
                                      className="atcpl"
                                      style={{
                                        color: payload.datas.atcc,
                                        backgroundColor: payload.datas.atcbc,
                                      }}
                                    >
                                      {atclabel}
                                    </button>
                                  )}
                                </figcaption>
                              </figure>
                              {product.price["reduction-label"] !== false && (
                                <span className="prom_txt sale">
                                  {product.price["reduction-label"]}
                                </span>
                              )}
                            </div>
                          )}
                          {!currentDesign && (
                            <>
                              <div
                                className="product-image"
                                style={{ ...productImageCss }}
                              >
                                <img src={product.image} alt="Product Image" />
                              </div>
                              <div className="product-info">
                                <MyHeading
                                  className="name"
                                  style={cssTextSettings}
                                >
                                  {product.name}
                                </MyHeading>

                                <Rating
                                  rate={product.review || 3}
                                  on={5}
                                  style={starCss}
                                />

                                <div
                                  className="price-section"
                                  style={{
                                    textAlign:
                                      priceStyle?.pricePosition || "center",
                                  }}
                                >
                                  <span className="price-txt" style={newPrice}>
                                    {" "}
                                    <span
                                      className="old-price"
                                      style={oldPrice}
                                    >
                                      $99.99
                                    </span>{" "}
                                    $9.99{" "}
                                  </span>
                                  <span className="price-over">
                                    Visual Builder is not showing actual product
                                    price. Prices here are used to show how it
                                    will look at Store Front
                                  </span>
                                </div>

                                {showat && (
                                  <button
                                    className="atcpl"
                                    style={{
                                      color: payload.datas.atcc,
                                      backgroundColor: payload.datas.atcbc,
                                    }}
                                  >
                                    {atclabel}
                                  </button>
                                )}
                              </div>
                            </>
                          )}
                        </li>
                      );
                    })}
                </ul>
              </div>

              {showPaginationSummary !== undefined &&
              showPaginationSummary !== null &&
              showPaginationSummary === false ? null : (
                <div className="pagination_bottom" style={cssTextSettings}>
                  <span className="pagination_bottom">
                    {" "}
                    Showing 1 - <span className="showcount"></span> of{" "}
                    <span className="totalcount">99</span> products
                  </span>
                </div>
              )}
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

class CategoryTitle extends React.Component {
  constructor(props) {
    super(props);
  }

  shouldComponentUpdate(nextProp, nextState) {
    if (!isEqual(this.props, nextProp)) {
      return true;
    }

    return false;
  }

  render() {
    const {
      dropzoneID,
      parentID,
      showBasicContent,
      showPreview,
      id,
      dropzoneProps,
      payload,
      options,
      ...rest
    } = this.props;

    if (showBasicContent) {
      const elements = state.getStorableState();
      let inDrop = false;

      if (Array.isArray(elements) && elements.length > 0) {
        const inlinedElements = inlineElements(elements);
        if (Array.isArray(inlinedElements) && inlinedElements.length > 0) {
          inlinedElements.forEach((element) => {
            if (element.type === this.props.type) inDrop = true;
          });
        } else inDrop = false;
      } else inDrop = false;

      return (
        <Draggable {...this.props} side={true}>
          <span className="dragger">
            {(Array.isArray(rest.icon) && (
              <FontAwesomeIcon icon={rest.icon} />
            )) || <Icon icon={rest.icon} />}
            <span>{l(rest.name)}</span>
            {(inDrop && <span className="added">{l("Added")}</span>) || (
              <span className="required">{l("Required")}</span>
            )}
          </span>
        </Draggable>
      );
    }

    if (showPreview) {
      return (
        <div>
          <InitProduct props={this.props} />
        </div>
      );
    }

    return (
      <Draggable {...this.props} minify={true}>
        <HoverBar
          datas={this.props}
          style={payload}
          parent={parentID}
          element={{ id, dropzoneID, parentID, payload }}
        />
        <InitProduct props={this.props} />
      </Draggable>
    );
  }
}

CategoryTitle.propTypes = {
  id: PropTypes.string.isRequired,
  showBasicContent: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(CategoryTitle);
